import { Course } from '@/domain/entities/course.entity'
import api, { HttpResponse, treatmentForErrors } from '../api'
import { Institution } from '@/domain/entities/institution.entity'
import { IInstitutionsService } from '@/services/contracts/institutions'

export class InstitutionsService implements IInstitutionsService {
  async update(
    id: string,
    institution: Institution,
  ): Promise<HttpResponse<{ institutions: Institution }, Error>> {
    const request = api.put(`/admin/institutions/${id}`, institution)
    return treatmentForErrors(request)
  }

  async loadAll(): Promise<
    HttpResponse<{ institutions: Institution[] }, Error>
  > {
    const request = api.get('/institutions')
    return treatmentForErrors(request)
  }

  async listById(
    id: string,
  ): Promise<
    HttpResponse<{ institution: Institution; courses: Course[] }, Error>
  > {
    const request = api.get(`/admin/institutions/${id}`)
    return treatmentForErrors(request)
  }
}
